import { Card, CardContent, CardMedia } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import type { ReactNode } from 'react';

interface MediaCardMediaComponentProps {
  children?: ReactNode;
}

interface MediaCardCardContentProps {
  children?: ReactNode;
}

interface MediaCardProps {
  children?: ReactNode;
}

export const MediaCardMediaComponent: React.FC<MediaCardMediaComponentProps> = ({ children }) => {
  return <CardMedia>{children}</CardMedia>;
};

export const MediaCardCardContent: React.FC<MediaCardCardContentProps> = ({ children }) => {
  return <CardContent>{children}</CardContent>;
};

export const MediaCard: React.FC<MediaCardProps> = ({ children }) => {
  const classes = styles();

  return (
    <Card className={classes.card} raised={true}>
      {children}
    </Card>
  );
};

const styles = makeStyles((theme: Theme) => ({
  card: {
    flexBasis: '300px',
    width: '300px',
    [theme.breakpoints.up(1600)]: {
      maxWidth: '336px',
    },
    [theme.breakpoints.between(1240, 1599)]: {
      maxWidth: '380px',
    },
    [theme.breakpoints.between(940, 1239)]: {
      maxWidth: '400px',
    },
    [theme.breakpoints.between(634, 939)]: {
      maxWidth: '440px',
    },
    flexGrow: 1,
  },
}));
